export default "__VITE_ASSET__BkLsI3T6__"